var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon fill-current",attrs:{"width":"10","height":"7","viewBox":"0 0 10 7","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1 1L5 5L9 1","stroke-width":"1.6"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }